import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import moment from 'moment';
import DateBlock from '../home/DateBlock';
import "./_studentDiaryHome.scss"
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import MultiSelect from "react-multi-select-component";
import NoticeModal from './NoticeModal';
import AddDiary from './AddDiary';
import DiaryResponseModal from './DiaryResponseModal';
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import DiaryTableRowDeleteModal from './DiaryTableRowDeleteModal';
import * as compose from "lodash.flowright";
import PdfViewModal from './pdfModal';
import ClassDiaryPreview from './ClassDiaryPreview';
import { Modal } from 'react-bootstrap';
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import {
    attachModuleGuard,
    AccessDeniedModal,
    AccessDeniedCard,
} from "../../../utils/moduleGuard";
import {
    getAuthorizedBranchIds,
    getAuthorizedClassIds,
    getAuthorizedSectionIds,
    filterByAuthorizedIds
} from "../../utils/authHelper";
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";

// /student-diary → "Diary" (see MODULE_ROUTES in moduleAccessGuard).
// module_key ONLY, never module_name: the sidebar group name is shared by sibling
// modules, and can() grants an action when ANY matched row allows it — matching the
// group would let another module's grant leak in.
const DIARY_MODULE = ["Diary"];



const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const DELETE_DIARY_ROW_DATA = gql`
   mutation($dairyAssignmentId:ID){
    deleteDairyAssignmentData(dairyAssignmentId:$dairyAssignmentId)
   }
 `;

const EDIT_NOTICE_DIARY_DATA = gql`
mutation($params:AddDairyAssignmentDetails){
    addDairyAssignmentDetails(params:$params)
}
`;



// Stream applies only to Intermediate — Class 11 / Class 12, ids 1 & 2. It sits
// between Class and Section and narrows the section list by each section's stream_id.
// This was previously [15, 16], which is wrong for this data: id 15 is Nursery and
// id 16 a disabled "Class 12" duplicate. Nursery was therefore treated as streamed,
// and because its sections carry stream_id NULL the stream test matched nothing and
// emptied the Section dropdown. (Same fix already applied in the Fee modules.)
const STREAM_CLASS_IDS = [1, 2];
const isStreamClass = (classId) => STREAM_CLASS_IDS.includes(parseInt(classId));

// ── Same services as the Fee Dashboard ───────────────────────────────────────
const GET_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
      getBranches(institution_id: $institution_id) {
        id
        branch_name
        sections {
          id
          class_id
          section_name
          stream_id
        }
      }
    }
  `;

// `classes` is a CSV of the class_ids each stream applies to, so the dropdown can be
// narrowed to the selected class without depending on which sections already exist.
const GET_STREAMS = gql`
    query {
      getStreams {
        id
        stream
        classes
      }
    }
  `;

const GET_CLASSES = gql`
    query($id: Int) {
      getExamClasses(id: $id) {
        id
        class
      }
    }
  `;

const GET_DIARY_DETAILS = gql`
  query($institute_id:Int,$branch_id:String,$dairy_assignment_type_id:Int,$from_date:String,$to_date:String){
    getStudentDairyAssignmentDetails(institute_id:$institute_id,branch_id:$branch_id,dairy_assignment_type_id:$dairy_assignment_type_id,from_date:$from_date,to_date:$to_date){
      dairy_assignment_creation_details {
        dairyAssigment_id title description file_path assignment_marks to_date from_date
        employee_id exam_id class_id subject_id section_ids Class Exam Section_Name subject_name
        branch_name
      }
      dairy_assignment_submitted_details {
        dairyAssignmentStatus_id dairy_assignment_id edu_student_id status upload_file_path comments
        submitted_time student_name student_mobile roll_no parent_name parent_mobile class_id exam_id
        section_id marks verifier_comments
      }
      total_students_details {
        edu_student_id student_name student_mobile roll_no parent_name parent_mobile class_id exam_id section_id
      }
    }
  }
`;

const GET_ORGANISATION_PROFILE = gql`
    query($institution_id: Int!) {
        getOrganisationProfile(institution_id: $institution_id) {
            id
            organisation_name
            logo
            complete_address
        }
    }
`;


// ── Multi-select checkbox dropdown (same component as Fee Dashboard) ──────────
class CheckboxDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.ref = React.createRef();
    }
    componentDidMount() { document.addEventListener("mousedown", this.handleOutside); }
    componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }
    handleOutside = (e) => {
        if (this.ref.current && !this.ref.current.contains(e.target)) this.setState({ open: false });
    };
    toggle = (id) => {
        const { value, onChange } = this.props;
        onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
    };
    render() {
        const { options, value, placeholder, onChange } = this.props;
        const { open } = this.state;
        const label = value.length === 0 ? placeholder
            : value.length === options.length ? `All (${options.length})`
                : value.length === 1 ? (options.find((o) => o.value === value[0])?.label || `${value.length} selected`)
                    : `${value.length} selected`;
        return (
            <div ref={this.ref} style={{ position: "relative" }}>
                <div onClick={() => this.setState({ open: !open })}
                    style={{ borderRadius: 10, border: "1.5px solid #e5e7eb", padding: "9px 14px", fontSize: 14, color: value.length ? "#1f2937" : "#9ca3af", background: "#f9fafb", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none", height: 40 }}>
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
                    <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
                </div>
                {open && (
                    <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.10)", zIndex: 9999, maxHeight: 220, overflowY: "auto" }}>
                        {options.length === 0 ? (
                            <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
                        ) : (<>
                            <div onClick={() => onChange(value.length === options.length ? [] : options.map((o) => o.value))}
                                style={{ padding: "8px 12px", fontSize: 12, fontWeight: 700, color: "#6366f1", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 8 }}>
                                <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />
                                Select All
                            </div>
                            {options.map((o) => (
                                <div key={o.value} onClick={() => this.toggle(o.value)}
                                    style={{ padding: "7px 12px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: value.includes(o.value) ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f9fafb" }}>
                                    <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                                    <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                                </div>
                            ))}
                        </>)}
                    </div>
                )}
            </div>
        );
    }
}

const TAB_CONFIG = [
    { key: "DIARY", label: "Diary", icon: "📋" },
    { key: "NOTICE", label: "Notice", icon: "✏️" },
];

const styles = {
    navScroll: {
        overflowX: "auto",
    },
    nav: {
        display: "flex",
        gap: 20,
        paddingBottom: 6,
        minWidth: "max-content",
    },
    navItem: {
        border: "none",
        background: "#f3f4f6",
        padding: "10px 16px",
        borderRadius: 10,
        fontWeight: 600,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 6,
        whiteSpace: "nowrap",
    },
    navItemActive: {
        background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
        color: "#fff",
    },
};


class StundentDiaryHome extends Component {
    constructor(props) {
        super(props);
        this.initialFetchDone = false;
        this.state = {
            branch: "",
            branchSearch: [],
            branchSearchval: "",
            // selectedYear: new Date().getFullYear().toString(),
            // ── Fee-dashboard style filters (same data + services) ──
            branches: [],
            getClasses: [],
            allStreams: [],
            classSearch: [],
            streamSearch: [],
            sectionSearch: [],
            branchMultiError: "",
            currentPage: 1,
            itemsPerPage: 10,
            getClassArr: [],
            classMultiError: "",
            classSelectedvalue: [],
            getSectionArr: [],
            sectionMultiError: "",
            sectionSelectedvalue: [],
            selectedOptionId: props.diaryType === "2" ? "2" : "1",
            loader: 0,
            submitted: false,
            DiaryTableRowDeleteModal: false,
            viewNoticeModal: false,
            editItem: null,
            branch: "",dingSpinner: 0,
            DiaryResponseModal: false,
            PdfViewModal: false,
            deleteId: "",
            spinnerStatus: "",
            noDateError: "",
            sortBy: "Date (Newest First)",
            previewModalOpen: false,
            previewData: null,
            studentDairyNoticeCreationDetails: [],
            studentDairyNoticeSubmissionDetails: [],
            studentDiaryNoticeViewStatus: [],
            existingDairyOrNoticeData: [],
            pdfData: [],
            // startDateCalender: moment(`${new Date().getFullYear()}-06-01`, 'YYYY-MM-DD').startOf('day').unix(),
            // endDateCalender: moment(`${new Date().getFullYear() + 1}-05-31`, 'YYYY-MM-DD').endOf('day').unix(),
            startDateCalender: moment(new Date()).subtract(1, "month").startOf('day').unix(),
            endDateCalender: moment(new Date()).startOf('day').unix(),
            orgProfile: {},
            accessDeniedShow: false,
        }

        this.guard = attachModuleGuard(this, DIARY_MODULE);
    };

    getLogoDataUrl = async (logoFile) => {
        if (!logoFile) return "";
        const url = logoFile.startsWith("http")
            ? logoFile
            : `https://support.rizee.in/files/${logoFile}`;
        try {
            const res = await fetch(url, { credentials: "include" });
            if (!res.ok) return url;
            const blob = await res.blob();
            return await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = () => resolve(url);
                reader.readAsDataURL(blob);
            });
        } catch {
            return url;
        }
    };

    loadOrgProfile = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_ORGANISATION_PROFILE,
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            const data = result.data?.getOrganisationProfile;
            const profile = {
                organisation_name: data?.organisation_name || "",
                logo: data?.logo || "",
                complete_address: data?.complete_address || "",
            };
            this.setState({ orgProfile: profile });
            return profile;
        } catch (err) {
            console.error("loadOrgProfile error:", err);
            return this.state.orgProfile;
        }
    };

    handlePrint = async () => {
        this.setState({ loader: 2 });
        try {
            const profile = await this.loadOrgProfile();
            const orgName = profile.organisation_name || "";
            const logoFile = profile.logo || "";
            const logoUrl = await this.getLogoDataUrl(logoFile);
            const orgAddress = profile.complete_address || "";

            const isDiary = this.state.selectedOptionId === "1";
            const typeName = isDiary ? "Diary" : "Notice";

            const dateRangeStr = `${moment.unix(this.state.startDateCalender).format("DD-MM-YYYY")} to ${moment.unix(this.state.endDateCalender).format("DD-MM-YYYY")}`;

            let rowsHtml = "";
            if (isDiary) {
                const { getClasses, branches, classSearch, sectionSearch, studentDairyNoticeCreationDetails } = this.state;
                const classNameOf = (id) => (getClasses.find((c) => Number(c.id) === Number(id))?.class) || "";
                const allSectionObjs = branches.flatMap((b) => b.sections || []);
                const sectionNameOf = (id) => (allSectionObjs.find((s) => Number(s.id) === Number(id))?.section_name) || "";

                const dedupeByLabel = (arr) => {
                    const seen = new Set();
                    return arr.filter((o) => (seen.has(o.label) ? false : (seen.add(o.label), true)));
                };
                const classSelectedvalue = dedupeByLabel(classSearch.map((id) => ({ value: id, label: classNameOf(id) })));
                const sectionSelectedvalue = dedupeByLabel(sectionSearch.map((id) => ({ value: id, label: sectionNameOf(id) })));

                classSelectedvalue.forEach((classValue) => {
                    sectionSelectedvalue.forEach((sectionValue) => {
                        const filteredData = studentDairyNoticeCreationDetails.filter(
                            (item) =>
                                item.Class === classValue.label &&
                                item.Section_Name === sectionValue.label
                        );
                        const uniqueDates = [...new Set(filteredData.map((d) => d.from_date))];
                        if (!uniqueDates.length) return;

                        uniqueDates.forEach((uniqueDate) => {
                            const data = filteredData.filter((r) => r.from_date === uniqueDate);
                            data.forEach((item, index) => {
                                const dateLabel = item?.from_date
                                    ? moment.unix(item.from_date).format("DD-MM-YYYY")
                                    : "";
                                rowsHtml += `
                                    <tr>
                                        ${index === 0 ? `
                                            <td rowspan="${data.length}">${dateLabel}</td>
                                            <td rowspan="${data.length}">${item.branch_name || "—"}</td>
                                            <td rowspan="${data.length}">${item.Class}</td>
                                            <td rowspan="${data.length}">${item.Section_Name}</td>
                                        ` : ""}
                                        <td>
                                            <div style="font-weight: 700; color: #1e293b;">${item?.subject_name || "—"}</div>
                                            <div style="font-size: 11px; color: #64748b; margin-top: 2px;">${item?.description || ""}</div>
                                        </td>
                                    </tr>
                                `;
                            });
                        });
                    });
                });
            } else {
                this.state.studentDairyNoticeCreationDetails.forEach((item, index) => {
                    const date = moment.unix(item.from_date).format("DD-MM-YYYY");
                    rowsHtml += `
                        <tr>
                            <td style="text-align: center;">${index + 1}</td>
                            <td>${date}</td>
                            <td>${item.branch_name || "—"}</td>
                            <td style="text-align: left;">${item?.description || ""}</td>
                        </tr>
                    `;
                });
            }

            const tableHeaderHtml = isDiary ? `
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Branch</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Subject / Description</th>
                    </tr>
                </thead>
            ` : `
                <thead>
                    <tr>
                        <th style="width: 60px; text-align: center;">#</th>
                        <th style="width: 120px;">Date</th>
                        <th>Branch</th>
                        <th>Description</th>
                    </tr>
                </thead>
            `;

            const printWindow = window.open("", "_blank", "width=1100,height=700");
            printWindow.document.write(`
                <html>
                <head>
                    <title>Student ${typeName} Report</title>
                    <style>
                        * { margin: 0; padding: 0; box-sizing: border-box; }
                        body { font-family: Arial, sans-serif; padding: 24px; color: #1e293b; background: #fff; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .header { display: flex; align-items: flex-start; gap: 16px; border-bottom: 2px solid #e2e8f0; padding-bottom: 16px; margin-bottom: 20px; }
                        .header img { max-height: 70px; width: auto; object-fit: contain; flex-shrink: 0; }
                        .header-details { flex: 1; }
                        .org-name { font-size: 22px; font-weight: 800; color: #0f172a; margin-bottom: 4px; text-transform: uppercase; letter-spacing: -0.02em; }
                        .org-address { font-size: 12px; color: #64748b; line-height: 1.5; max-width: 600px; }
                        .report-meta { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding: 12px 16px; background: #f8fafc; border-radius: 8px; border: 1px solid #f1f5f9; }
                        .report-title { font-size: 16px; font-weight: 700; color: #0f172a; }
                        .report-date { font-size: 13px; color: #64748b; font-weight: 500; }
                        table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 13px; }
                        th { background: #f1f5f9; color: #475569; padding: 10px 12px; text-align: left; font-weight: 700; border: 1px solid #e2e8f0; text-transform: uppercase; font-size: 11px; letter-spacing: 0.5px; }
                        td { padding: 12px; border: 1px solid #e2e8f0; vertical-align: top; color: #334155; line-height: 1.4; }
                        tr:nth-child(even) td { background: #f8fafc; }
                        @media print {
                            body { padding: 0; }
                            .report-meta { background: none; border: none; padding: 12px 0; border-bottom: 1px solid #e2e8f0; border-radius: 0; }
                        }
                    </style>
                </head>
                <body>
                    <div class="header">
                        ${logoUrl ? `<img src="${logoUrl}" />` : ""}
                        <div class="header-details">
                            <div class="org-name">${orgName}</div>
                            <div class="org-address">${orgAddress}</div>
                        </div>
                    </div>
                    <div class="report-meta">
                        <div class="report-title">Student ${typeName} Registry</div>
                        <div class="report-date">Period: <strong>${dateRangeStr}</strong></div>
                    </div>
                    <table>
                        ${tableHeaderHtml}
                        <tbody>
                            ${rowsHtml || '<tr><td colspan="5" style="text-align: center; color: #64748b; padding: 30px;">No entries available in this range.</td></tr>'}
                        </tbody>
                    </table>
                    <script>
                        function doPrint() {
                            window.print();
                        }
                        var img = document.querySelector('.header img');
                        if (img && !img.complete) {
                            img.onload = doPrint;
                            img.onerror = doPrint;
                        } else {
                            setTimeout(doPrint, 350);
                        }
                    </script>
                </body>
                </html>
            `);
            printWindow.document.close();
            printWindow.focus();
            this.setState({ loader: 0 });
        } catch (err) {
            console.error("Print error:", err);
            this.setState({ loader: 0 });
        }
    };

    checkAndFetchInitialData = () => {
        if (this.state.branchSearch && this.state.branchSearch.length > 0 && !this.initialFetchDone) {
            this.initialFetchDone = true;
            this.getDisplayMultiSelectData({ preventDefault: () => { } }, { auto: true });
        }
    };

    async componentDidMount() {
        // is_view === 0 → don't fetch anything. Every read on this page is an imperative
        // client.query() (there are no read HOCs to put a `skip` on), so bailing out here
        // is what keeps the module's data off the wire.
        if (!this.guard.canView()) return;

        await this.getClasses();
        // getStreams is NOT fetched here — it loads lazily, only once the selection
        // actually includes a stream class. See ensureStreamsLoaded().
        await this.getBranches();
        this.loadOrgProfile();
        // Branch comes from the header (NavbarOne) — re-scope when it changes.
        this.offBranchScope = onBranchScopeChange(() => this.getBranches());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    // Distinct stream ids of stream-class sections within the given classes.
    streamIdsFor = (branchObjs, classIds) => [...new Set(branchObjs.flatMap(b => b.sections || []).filter(s => classIds.map(Number).includes(Number(s.class_id)) && isStreamClass(s.class_id) && s.stream_id).map(s => Number(s.stream_id)))];

    // Stream OPTIONS come from the getStreams API, not from the sections that happen to
    // exist. Deriving them from sections showed only the streams that already had a
    // section created, so an institute running MPC/BiPC/CEC/MEC saw a single entry.
    // A stream is offered when its `classes` CSV covers one of the selected stream
    // classes; a stream with no mapping applies to all of them.
    streamOptionsFor = (classIds) => {
        const wanted = (classIds || []).filter((id) => isStreamClass(id)).map(String);
        if (!wanted.length) return [];
        return (this.state.allStreams || [])
            .filter((st) => {
                const applies = String(st.classes || "").split(",").map((x) => x.trim()).filter(Boolean);
                return applies.length === 0 || applies.some((c) => wanted.includes(c));
            })
            .map((st) => ({ value: Number(st.id), label: st.stream }));
    };

    // Section ids for the given classes; stream-class sections are further narrowed
    // by the selected stream ids (non-stream classes ignore the stream filter).
    sectionIdsFor = (branchObjs, classIds, streamIds) => branchObjs.flatMap(b => b.sections || []).filter(s => classIds.map(Number).includes(Number(s.class_id))).filter(s => !isStreamClass(s.class_id) || streamIds.map(Number).includes(Number(s.stream_id))).map(s => s.id);

    componentDidUpdate(prevProps) {
        // Route-driven type switch (/student-diary ↔ /notice). The two routes reuse
        // this instance via <Switch>, so react to the diaryType prop instead of remount.
        const newType = this.props.diaryType === "2" ? "2" : "1";
        const oldType = prevProps.diaryType === "2" ? "2" : "1";
        if (newType !== oldType && newType !== this.state.selectedOptionId) {
            this.setState({
                selectedOptionId: newType,
                studentDairyNoticeCreationDetails: [],
                studentDairyNoticeSubmissionDetails: [],
                studentDiaryNoticeViewStatus: [],
                noDateError: "",
                classMultiError: "",
                sectionMultiError: "",
                currentPage: 1,
            }, () => {
                this.getDisplayMultiSelectData({ preventDefault: () => { } }, { auto: true });
            });
        }
    }

    // ── Same service as Fee Dashboard: getBranches (branches + nested sections) ──
    getBranches = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            // The header's branch selection (NavbarOne) IS this page's branch filter, and
            // it never widens past the branches the user is authorized for.
            let branches = scopeBranches(result.data.getBranches || []);
            // Sections are scoped once, here at the source: the Class/Stream/Section filter
            // options, the cascade helpers (streamIdsFor / sectionIdsFor) and the registry
            // table all derive from branch.sections, so narrowing it here scopes the whole
            // page. Both dimensions apply — a section is kept only when its own id is
            // assigned AND its class is assigned. Either cookie being empty is a no-op.
            const allowedClasses = getAuthorizedClassIds();
            const allowedSections = getAuthorizedSectionIds();
            if (allowedClasses.length || allowedSections.length) {
                branches = branches.map((b) => ({
                    ...b,
                    sections: filterByAuthorizedIds(
                        filterByAuthorizedIds(b.sections, allowedSections, "id"),
                        allowedClasses,
                        "class_id"
                    ),
                }));
            }
            const allBranchIds = branches.map((b) => b.id);
            const allClassIds = [...new Set(branches.flatMap((b) => (b.sections || []).map((s) => Number(s.class_id))))];
            const allStreamIds = this.streamIdsFor(branches, allClassIds);
            const allSectionIds = this.sectionIdsFor(branches, allClassIds, allStreamIds);
            this.setState({
                branches,
                branchSearch: allBranchIds,
                classSearch: allClassIds,
                streamSearch: allStreamIds,
                sectionSearch: allSectionIds,
            }, () => {
                this.ensureStreamsLoaded(allClassIds);
                this.checkAndFetchInitialData();
            });
        } catch {
            // ignore
        }
    };

    // Fetch getStreams ONLY when the current class selection contains a stream class
    // (Intermediate — see STREAM_CLASS_IDS). Every other class hides the Stream filter,
    // so the API is never called for them. Loaded at most once per page visit.
    // Accepts a single class id or a list, so both the registry filters and the
    // Add Diary form can request the load.
    ensureStreamsLoaded = async (classIds) => {
        const ids = Array.isArray(classIds) ? classIds : [classIds];
        const needsStreams = ids.some((id) => isStreamClass(id));
        if (!needsStreams || this.state.allStreams.length > 0 || this.streamsLoading) return;
        this.streamsLoading = true;
        await this.getStreamsList();
        this.streamsLoading = false;
    };

    // ── getStreams (id + label + applicable classes) — populates the Stream filter ──
    getStreamsList = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_STREAMS,
                fetchPolicy: "network-only",
            });
            this.setState({ allStreams: result.data.getStreams || [] }, () => {
                // The initial selection was derived from the sections that exist, so it
                // covers only the streams already in use. Widen it to every stream the API
                // reports for the selected classes, otherwise the filter reads as
                // pre-narrowed to one stream. This only ADDS ids, and sectionIdsFor keeps
                // a section when its stream is in the list — so the Section list can only
                // grow, never shrink.
                const known = this.streamOptionsFor(this.state.classSearch).map((o) => o.value);
                if (!known.length) return;
                const streamSearch = [...new Set([...this.state.streamSearch.map(Number), ...known])];
                const selectedBranchObjs = this.state.branchSearch.length > 0
                    ? this.state.branches.filter((b) => this.state.branchSearch.map(Number).includes(Number(b.id)))
                    : this.state.branches;
                this.setState({
                    streamSearch,
                    sectionSearch: this.sectionIdsFor(selectedBranchObjs, this.state.classSearch, streamSearch),
                });
            });
        } catch {
            // ignore
        }
    };

    // ── Same service as Fee Dashboard: getExamClasses ──
    getClasses = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_CLASSES,
                variables: { id: 1 },
                fetchPolicy: "network-only",
            });
            // Scoped once at the source — the Class filter and the registry table's
            // class labels both read this. Empty class_ids leaves the list untouched.
            this.setState({
                getClasses: filterByAuthorizedIds(
                    result.data.getExamClasses || [],
                    getAuthorizedClassIds(),
                    "id"
                ),
            });
        } catch {
            // ignore
        }
    };

    handleMultipleSelectInputChange = (e, name) => {
        if (name == "class") {
            let classSelectedvalue = [];
            let getSectionArr = [];

            if (e.length > 0) {
                for (let i = 0; i < e.length; i++) {
                    classSelectedvalue.push({ label: e[i].label, value: e[i].value });
                }

                let selectedClasses = classSelectedvalue.map((item) => item.value);
                let uniqueSections = [];

                selectedClasses.forEach((val1) => {
                    let individualsectionValues = [...new Set(
                        this.props.globals.b_e_c_s_data
                            .filter((item) => item.branch_id == this.state.branchSearch && item.class_id == parseInt(val1))
                            .map((item1) => item1.section_id)
                    )].sort();
                    if (individualsectionValues.length > 0) uniqueSections.push(...individualsectionValues);
                });

                if (uniqueSections.length > 0) {
                    [...new Set(uniqueSections)].forEach((val) => {
                        let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                        if (individualSectionData) {
                            getSectionArr.push({ value: individualSectionData.id, label: individualSectionData.section_name });
                        }
                    });
                }

                this.setState({
                    classSelectedvalue,
                    classMultiError: "",
                    sectionMultiError: "",
                    getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                });
            } else {
                this.setState({
                    classSelectedvalue,
                    classMultiError: "",
                    sectionMultiError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                });
            }
        }

        if (name == "section") {
            let sectionSelectedvalue = [];
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    sectionSelectedvalue.push({ label: e[i].label, value: e[i].value });
                }
                this.setState({ sectionSelectedvalue, classMultiError: "", sectionMultiError: "" });
            }
        }
    }

    dropDownGetValues(fieldname) {
        let getArray = [];
        if (fieldname == "branchSearch") {
            let uniqueBranches = [...new Set(this.props.globals.b_e_c_s_data.map((item) => item.branch_id))];
            uniqueBranches.map((val) => {
                let individualBranchData = this.props.globals.globalBranches.find((item1) => +item1?.id === +val);
                const newObj = {
                    value: individualBranchData?.id,
                    label: individualBranchData?.branch_name
                }
                getArray.push(newObj);
            });
        }
        return getArray;
    }

    selecthandleBranch = (name, value) => {
        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globalBranches.find((a) => +a?.id === +value);
                let getClassArr = [];
                let getSectionArr = [];

                if (branchSearchData != null) {
                    // Class selection — directly from branch
                    let uniqueClasses = [...new Set(
                        this.props.globals.b_e_c_s_data
                            .filter((item) => item.branch_id == branchSearchData.id)
                            .map((item1) => item1.class_id)
                    )].sort();

                    uniqueClasses.forEach((val) => {
                        let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                        if (individualClassData) {
                            getClassArr.push({ value: individualClassData.id, label: individualClassData.class });
                        }
                    });

                    let selectedClasses = getClassArr.map((item) => item.value);
                    let uniqueSections = [];

                    if (selectedClasses.length > 0) {
                        selectedClasses.forEach((val1) => {
                            let individualsectionValues = [...new Set(
                                this.props.globals.b_e_c_s_data
                                    .filter((item) => item.branch_id == branchSearchData.id && item.class_id == parseInt(val1))
                                    .map((item1) => item1.section_id)
                            )].sort();
                            if (individualsectionValues.length > 0) uniqueSections.push(...individualsectionValues);
                        });
                    }

                    if (uniqueSections.length > 0) {
                        [...new Set(uniqueSections)].forEach((val) => {
                            let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                            if (individualSectionData) {
                                getSectionArr.push({ value: individualSectionData.id, label: individualSectionData.section_name });
                            }
                        });
                    }

                    this.setState({
                        branchSearchval: { value: branchSearchData.id, label: branchSearchData.branch_name },
                        branch: branchSearchData.branch_name,
                        branchError: "",
                        branch_id: branchSearchData.id,
                        getClassArr,
                        classSelectedvalue: getClassArr,
                        getSectionArr,
                        sectionSelectedvalue: getSectionArr,
                        noDateError: "",
                        classMultiError: "",
                        sectionMultiError: "",
                        studentDairyNoticeCreationDetails: [],
                    });
                }
            }
        }
        this.setState({ [name]: value });
    }



    getDisplayMultiSelectData = async (e, options = {}) => {
        if (e && e.preventDefault) e.preventDefault();

        // Automatic loads (initial mount, year/route change, after save/delete) pass
        // { auto: true } so the "Please select…" validation only shows when the user
        // actually clicks Search — not while branches are still loading.
        const isAuto = options.auto === true;
        const { branchSearch, classSearch, sectionSearch } = this.state;

        if (!branchSearch.length) {
            if (!isAuto) this.setState({ branchMultiError: "Please select branch" });
            return "";
        }
        if (!classSearch.length) {
            if (!isAuto) this.setState({ classMultiError: "Please select class" });
            return "";
        }
        if (!sectionSearch.length) {
            if (!isAuto) this.setState({ sectionMultiError: "Please select section" });
            return "";
        }

        this.setState({ loader: 1, noDateError: "", branchMultiError: "", classMultiError: "", sectionMultiError: "" });

        try {
            const result = await this.props.client.query({
                query: GET_DIARY_DETAILS,
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id: branchSearch.join(","),
                    dairy_assignment_type_id: parseInt(this.state.selectedOptionId),
                    from_date: this.state.startDateCalender.toString(),
                    to_date: this.state.endDateCalender.toString(),
                },
                fetchPolicy: "network-only",
            });

            const details = result.data.getStudentDairyAssignmentDetails || [];
            let creation = [];
            let submitted = [];
            let totals = [];
            details.forEach((node) => {
                if (node.dairy_assignment_creation_details?.length) creation.push(...node.dairy_assignment_creation_details);
                if (node.dairy_assignment_submitted_details?.length) submitted.push(...node.dairy_assignment_submitted_details);
                if (node.total_students_details?.length) totals.push(...node.total_students_details);
            });

            const classFilter = classSearch.map(String);
            const sectionFilter = sectionSearch.map(String);
            const filteredArray = creation.filter((item) => {
                const itemClassId = (item.class_id || "").split(",");
                const itemSectionIds = (item.section_ids || "").split(",");
                const classMatch = itemClassId.some((id) => classFilter.includes(id));
                const sectionMatch = itemSectionIds.some((id) => sectionFilter.includes(id));
                return classMatch && sectionMatch;
            });

            this.setState({
                studentDairyNoticeCreationDetails: filteredArray,
                studentDairyNoticeSubmissionDetails: submitted,
                studentDiaryNoticeViewStatus: totals,
                currentPage: 1,
                submitted: false,
                loader: 0,
                noDateError: filteredArray.length ? "" : "No Data Available",
            });
        } catch (err) {
            this.setState({ loader: 0, noDateError: "No Data Available" });
        }
    }

    handleInputRadioChange = (e) => {
        const { name, value } = e.target;
        if (name == "radioOption") {
            const selectedOptionId = e.target.id;
            if (selectedOptionId != this.state.selectedOptionId) {
                this.setState({
                    selectedOptionId,
                    studentDairyNoticeCreationDetails: [],
                    noDateError: "",
                    classMultiError: "",
                    sectionMultiError: "",
                    currentPage: 1,
                });
                // BY DEFAULT ALL SELETED DATA TO WRITE BELOW CONDITION
                let e = {
                    preventDefault: function () {

                    }
                }
                setTimeout(() => {
                    this.getDisplayMultiSelectData(e)

                }, 1000)
                // =================================================================================
            }
        }
    };

    applyCallback = (startDate, endDate) => {
        if (startDate.isAfter(endDate)) {
            this.setState({ noDateError: "Start date cannot be after end date." });
            return;
        }
        this.setState({
            startDateCalender: startDate.startOf('day').unix(),
            endDateCalender: endDate.startOf('day').unix(),
            studentDiaryNoticeViewStatus: [],
            studentDairyNoticeSubmissionDetails: [],
            studentDairyNoticeCreationDetails: [],
            noDateError: "",
        }, () => {
            this.getDisplayMultiSelectData({ preventDefault: () => { } }, { auto: true });
        });
    }

    // After a diary/notice is saved, close the modal and re-fetch the list in place
    // (no full-page reload). getDisplayMultiSelectData uses selectedOptionId, so the
    // diary route refetches diary and the notice route refetches notice.
    handleModalSubmitSuccess = () => {
        this.setState({ viewDiaryMOdal: false, viewNoticeModal: false });
        this.getDisplayMultiSelectData({ preventDefault: () => { } }, { auto: true });
    };

    handleDelete = async (i) => {
        // Last gate before deleteDairyAssignmentData leaves the client.
        if (!this.guard.requireDelete()) return;

        this.setState({
            spinnerStatus: "1",
            submitError: ""
        });
        await this.props.deleteDairyAssignmentData({
            variables: {
                dairyAssignmentId: parseInt(this.state.deleteId)
            },
            update: (store, { data }) => {
                if (data.deleteDairyAssignmentData == true) {
                    // Show the success banner briefly, then close + re-fetch the list in
                    // place (no full-page reload). getDisplayMultiSelectData uses
                    // selectedOptionId, so diary deletes refetch diary and notice
                    // deletes refetch notice.
                    this.setState({ currentStep: 5, spinnerStatus: "" });
                    setTimeout(() => {
                        this.setState({ DiaryTableRowDeleteModal: false, currentStep: 1 });
                        this.getDisplayMultiSelectData({ preventDefault: () => { } }, { auto: true });
                    }, 1200);
                } else {
                    this.setState({ spinnerStatus: "", submitError: "Failed to delete. Please try again." });
                }
            }
        });
    }




    // "add-diary" is not just a tab — it's how the create/edit diary form is opened, so
    // routing to it is an is_edit action. Checked BEFORE history.push, otherwise
    // react-router would already have moved the user into the form and the check would
    // come too late to stop anything. Navigating back to "registry" is a plain read.
    setActiveTab = (tab) => {
        if (tab === "add-diary" && !this.guard.requireEdit()) return;

        if (tab !== "add-diary") this.setState({ editItems: null });
        this.props.history.push(`/student-diary/${tab}`);
    };

    // Opens the delete-confirm modal. Gated so a role without is_delete gets Access
    // Denied instead of a confirm dialog for a delete that can't happen. handleDelete
    // re-checks below, since that's where the mutation actually fires.
    openDeleteModal = (row) => {
        if (!this.guard.requireDelete()) return;
        this.setState({ DiaryTableRowDeleteModal: true, deleteId: row.dairyAssigment_id });
    };

    // Row "Edit Full Day" — loads the day's entries into the create/edit form.
    // The grant is checked FIRST, ahead of the 3-day age rule: a role without is_edit
    // should be told they lack access, not told the diary is too old to edit.
    openEditDiary = (row) => {
        if (!this.guard.requireEdit()) return;

        const daysDifference = moment().startOf('day').diff(moment.unix(row.uniqueDate).startOf('day'), 'days');
        if (daysDifference > 3) {
            alert("You cannot edit a diary older than 3 days. Try creating it for today.");
            return;
        }
        this.setState({ editItems: row.entries }, () => this.setActiveTab("add-diary"));
    };

    render() {
        // is_view === 0 → the diary data is never rendered, and componentDidMount bails
        // out before fetching any of it. Also blocks the "add-diary" route being reached
        // by URL, since the whole component renders Access Denied instead.
        if (!this.guard.canView()) {
            return (
                <div className="studentDiary-page">
                    <AccessDeniedCard />
                </div>
            );
        }

        const { match } = this.props;
        const tabParam = match && match.params && match.params.tab;
        const activeTab = ["registry", "add-diary"].includes(tabParam) ? tabParam : "registry";

        let sortedData = [...this.state.studentDairyNoticeCreationDetails];
        if (this.state.sortBy === "Date (Newest First)") {
            sortedData.sort((a, b) => b.from_date - a.from_date);
        } else if (this.state.sortBy === "Date (Oldest First)") {
            sortedData.sort((a, b) => a.from_date - b.from_date);
        } else if (this.state.sortBy === "Class/Section (A-Z)") {
            sortedData.sort((a, b) => {
                const classA = a.Class || "";
                const classB = b.Class || "";
                if (classA !== classB) return classA.localeCompare(classB);
                const secA = a.Section_Name || "";
                const secB = b.Section_Name || "";
                return secA.localeCompare(secB);
            });
        }


        const isDiary = this.state.selectedOptionId === "1";
        const typeName = isDiary ? "Diary" : "Notice";
        const recordCount = this.state.studentDairyNoticeCreationDetails.length;

        // ── Fee-dashboard style cascading filter options (same data + services) ──
        const { branches, getClasses, allStreams, branchSearch, classSearch, streamSearch, sectionSearch } = this.state;

        const selectedBranchObjs = branchSearch.length > 0
            ? branches.filter((b) => branchSearch.map(Number).includes(Number(b.id)))
            : branches;


        const branchClassIds = new Set(selectedBranchObjs.flatMap((b) => (b.sections || []).map((s) => Number(s.class_id))));
        const classOptions = getClasses
            .filter((c) => branchClassIds.size === 0 || branchClassIds.has(Number(c.id)))
            .map((c) => ({ value: c.id, label: c.class }));

        // Stream filter — shown whenever a stream class (Class 11 / 12) is selected, and
        // populated from the getStreams API so every configured stream is selectable.
        // Falls back to the section-derived ids until the API response lands.
        const apiStreamOptions = this.streamOptionsFor(classSearch);
        const streamOptions = apiStreamOptions.length
            ? apiStreamOptions
            : this.streamIdsFor(selectedBranchObjs, classSearch)
                .map((id) => ({ value: id, label: (allStreams.find((st) => Number(st.id) === Number(id))?.stream) || `Stream ${id}` }));
        const showStream = classSearch.some((id) => isStreamClass(id));

        const sectionOptions = selectedBranchObjs
            .flatMap((b) => b.sections || [])
            .filter((s) => classSearch.length === 0 || classSearch.map(Number).includes(Number(s.class_id)))
            .filter((s) => !isStreamClass(s.class_id) || streamSearch.map(Number).includes(Number(s.stream_id)))
            .map((s) => ({ value: s.id, label: s.section_name }));

        // The diary table groups rows by class/section *name*, so map selected ids → labels.
        const classNameOf = (id) => (getClasses.find((c) => Number(c.id) === Number(id))?.class) || "";
        const allSectionObjs = branches.flatMap((b) => b.sections || []);
        const sectionNameOf = (id) => (allSectionObjs.find((s) => Number(s.id) === Number(id))?.section_name) || "";

        const dedupeByLabel = (arr) => {
            const seen = new Set();
            return arr.filter((o) => (seen.has(o.label) ? false : (seen.add(o.label), true)));
        };
        const classSelectedvalue = dedupeByLabel(classSearch.map((id) => ({ value: id, label: classNameOf(id) })));
        const sectionSelectedvalue = dedupeByLabel(sectionSearch.map((id) => ({ value: id, label: sectionNameOf(id) })));

        const formattedRegistryData = [];
        if (isDiary) {
            classSelectedvalue.forEach((classValue) => {
                sectionSelectedvalue.forEach((sectionValue) => {
                    const filteredData = sortedData.filter(
                        (item) => item.Class === classValue.label && item.Section_Name === sectionValue.label
                    );
                    const uniqueDates = [...new Set(filteredData.map((d) => d.from_date))];
                    uniqueDates.forEach((uniqueDate) => {
                        const data = filteredData.filter((r) => r.from_date === uniqueDate);
                        const firstItem = data[0];
                        
                        let seenStudents = this.state.studentDairyNoticeSubmissionDetails.filter(
                            (item) => item.status == 1 && item.dairy_assignment_id == firstItem.dairyAssigment_id
                        );
                        let totalStudents = this.state.studentDiaryNoticeViewStatus || [];
                        
                        let seenStudentsdata = seenStudents.map((item) => String(item.edu_student_id));
                        let nonseenStudents = totalStudents
                            .filter((item1) => String(firstItem.class_id).split(',').includes(String(item1.class_id)))
                            .filter((item2) => String(firstItem.section_ids).split(',').includes(String(item2.section_id)))
                            .filter((item3) => !seenStudentsdata.includes(String(item3.edu_student_id)));

                        formattedRegistryData.push({
                            id: `${classValue.value}-${sectionValue.value}-${uniqueDate}`,
                            date: moment.unix(firstItem.from_date).format("DD-MM-YYYY"),
                            branch: firstItem.branch_name || "—",
                            className: firstItem.Class,
                            sectionName: firstItem.Section_Name,
                            classLabel: classValue.label,
                            sectionLabel: sectionValue.label,
                            uniqueDate: uniqueDate,
                            entries: data,
                            dairyAssigment_id: firstItem.dairyAssigment_id,
                            seenCount: seenStudents.length,
                            nonseenCount: nonseenStudents.length
                        });
                    });
                });
            });

            // Ensure newest is on top across all classes and sections
            formattedRegistryData.sort((a, b) => b.uniqueDate - a.uniqueDate);
        }

        const articlecolumns = [
            { dataField: 'date', text: 'Date', sort: true, headerStyle: { width: '120px' } },
            { dataField: 'branch', text: 'Branch', sort: true },
            { dataField: 'className', text: 'Class', sort: true },
            { dataField: 'sectionName', text: 'Section', sort: true },
            {
                dataField: 'viewStatus',
                text: 'View Status',
                isDummyField: true,
                formatter: (cellContent, row) => (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <span 
                            style={{ cursor: 'pointer', color: '#6366f1', fontWeight: '500' }}
                            onClick={() => this.setState({ DiaryResponseModal: true, deleteId: row.dairyAssigment_id, modalDefaultTab: "1" })}
                        >
                            Seen: {row.seenCount}
                        </span>
                        <span 
                            style={{ cursor: 'pointer', color: '#6366f1', fontWeight: '500' }}
                            onClick={() => this.setState({ DiaryResponseModal: true, deleteId: row.dairyAssigment_id, modalDefaultTab: "0" })}
                        >
                            Not Seen: {row.nonseenCount}
                        </span>
                    </div>
                )
            },
            {
                dataField: 'actions',
                text: 'Actions',
                isDummyField: true,
                formatter: (cellContent, row) => (
                    <div>
                        <button
                            className="diary-action-btn view"
                            title="Class Preview"
                            onClick={() => this.setState({ 
                                previewModalOpen: true, 
                                previewData: { classLabel: row.classLabel, sectionLabel: row.sectionLabel, date: row.uniqueDate, entries: row.entries }
                            })}
                            style={{ marginRight: "6px" }}
                        ><i className="fal fa-book-open" /></button>
                        <button
                            className="diary-action-btn edit"
                            title="Edit Full Day"
                            onClick={() => this.openEditDiary(row)}
                        ><i className="fas fa-edit" /></button>
                    </div>
                )
            }
        ];

        const noticeColumns = [
            {
                dataField: 'serial',
                text: '#',
                isDummyField: true,
                formatter: (cellContent, row, rowIndex) => rowIndex + 1,
                headerStyle: { width: '60px' }
            },
            {
                dataField: 'from_date',
                text: 'Date',
                sort: true,
                formatter: (cellContent, row) => moment.unix(row.from_date).format("DD-MM-YYYY"),
                headerStyle: { width: '120px' }
            },
            {
                dataField: 'branch_name',
                text: 'Branch',
                sort: true,
                formatter: (cellContent, row) => row.branch_name || "—"
            },
            {
                dataField: 'description',
                text: 'Description',
                formatter: (cellContent, row) => <div style={{ textAlign: "left" }}>{row.description}</div>
            },
            {
                dataField: 'file_path',
                text: 'Notice File',
                formatter: (cellContent, row) => row.file_path ? (
                    <span
                        className="diary-notice-link"
                        onClick={() => this.setState({ PdfViewModal: true, pdfData: [row] })}
                    >
                        <i className="fas fa-file-pdf" /> View Notice
                    </span>
                ) : (
                    <span style={{ color: "#cbd5e1" }}>—</span>
                )
            },
            {
                dataField: 'status',
                text: 'Status',
                isDummyField: true,
                formatter: (cellContent, row) => (
                    <button
                        className="diary-action-btn view"
                        title="View responses"
                        onClick={() => this.setState({ DiaryResponseModal: true, deleteId: row.dairyAssigment_id })}
                    >
                        <i className="fas fa-eye" />
                    </button>
                )
            },
            {
                dataField: 'delete',
                text: 'Delete',
                isDummyField: true,
                formatter: (cellContent, row) => (
                    <button
                        className="diary-action-btn view"
                        title="Delete Notice"
                        onClick={() => this.openDeleteModal(row)}
                    >
                        <i className="fas fa-trash-alt" />
                    </button>
                )
            }
        ];

        return (
            <div className="studentDiary-page">
                <Container fluid className="px-0">

                    {/* ── Tab Navigation ── */}
                    {/* <Row className="mb-1">
                    <Col xl={12}>
                        <div className="diary-tab-nav-wrapper">
                            <div className="diary-tab-nav">
                                <button
                                    type="button"
                                    id="1"
                                    name="radioOption"
                                    onClick={this.handleInputRadioChange}
                                    className={`diary-tab-btn ${isDiary ? "active" : ""}`}
                                >
                                    📋 Diary
                                </button>
                                <button
                                    type="button"
                                    id="2"
                                    name="radioOption"
                                    onClick={this.handleInputRadioChange}
                                    className={`diary-tab-btn ${!isDiary ? "active" : ""}`}
                                >
                                    ✏️ Notice
                                </button>
                            </div>
                        </div>
                    </Col>
                </Row> */}

                    {/* ── Add New Section Card ── */}
                    {/* <Row>
                    <Col xl={12}>
                        <div className="diary-section-card">
                            <div className="diary-section-header">
                                <span className="diary-section-dot" />
                                Add New {typeName}
                            </div>
                            <div className="diary-section-body">
                                <div className="diary-add-bar">
                                    <button
                                        className="diary-add-btn"
                                        onClick={() => {
                                            if (isDiary) {
                                                this.setState({ viewDiaryMOdal: true, existingDairyOrNoticeData: [], noDateError: "" });
                                            } else {
                                                this.setState({ viewNoticeModal: true, noDateError: "" });
                                            }
                                        }}
                                    >
                                        <i className="fas fa-plus" /> Add {typeName}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row> */}

                    {/* ── Registry Section Card ── */}
                    <Row>
                        <Col xl={12}>
                            <div className="diary-section-card">
                                {/* ── Diary / Notice Tabs ── */}
                                <div className="diary-tabbar" style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8, margin: 0 }}>
                                        {[
                                            { id: "registry", label: "Registry", icon: "fal fa-clipboard" },
                                            { id: "add-diary", label: "Add Diary", icon: "fal fa-plus-circle" },
                                        ].map((tab) => {
                                            const active = activeTab === tab.id;
                                            return (
                                                <li className="nav-item" key={tab.id}>
                                                    <a
                                                        className={`nav-link ${active ? "active" : ""}`}
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.setActiveTab(tab.id);
                                                        }}
                                                        style={{
                                                            cursor: "pointer",
                                                            fontWeight: 700,
                                                            fontSize: 14,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 8,
                                                            padding: "12px 20px",
                                                            color: active ? "#6366f1" : "#4b5563",
                                                            background: active ? "#fff" : "transparent",
                                                            borderColor: active ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                                                            borderWidth: "1.5px",
                                                            borderBottomWidth: active ? "2px" : "1.5px",
                                                            borderRadius: "10px 10px 0 0",
                                                            transition: "all 0.15s ease",
                                                            marginBottom: "-1.5px",
                                                            textDecoration: "none",
                                                        }}
                                                    >
                                                        <i className={tab.icon} />
                                                        {tab.label}
                                                    </a>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>

                                {activeTab === "registry" ? (<>
                                <div className="diary-section-header">
                                    <span className="diary-section-icon">
                                        <i className={isDiary ? "fal fa-clipboard" : "fal fa-bullhorn"} />
                                    </span>
                                    <span className="diary-section-titles">
                                        <span className="diary-section-name">{typeName} Registry</span>
                                        <span className="diary-section-sub">
                                            {isDiary ? "Daily homework and assignments" : "Class circulars and announcements"}
                                        </span>
                                    </span>
                                    <div className="diary-header-actions">
                                        <Form.Group className="customDate mb-0" controlId="StartDate" style={{ width: "220px" }}>
                                            <DateBlock applyCallback={this.applyCallback} start={this.start} end={this.end} data="dairyOrNotice" />
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="diary-section-body">
                                    {/* ── Filters (same dropdowns, data & services as Fee Dashboard) ── */}
                                    <Row className="diary-fee-filters align-items-start">
                                        {/* <Col lg={3} md={6} sm={12}>
                                            <label className="diary-filter-label2">Academic Year</label>
                                            <select
                                                value={yearSearch}
                                                onChange={this.handleYearChange}
                                                className="diary-fee-input"
                                            >
                                                {academicYears.map((y) => (
                                                    <option key={y.id} value={y.id}>{y.academic_year}</option>
                                                ))}
                                            </select>
                                        </Col> */}

                                        {/* Sort By removed as requested */}

                                        {/* No Branch filter — the header's branch selection scopes this page. */}

                                        <Col lg={3} md={6} sm={12}>
                                            <label className="diary-filter-label2">Class</label>
                                            <CheckboxDropdown
                                                options={classOptions}
                                                value={classSearch}
                                                onChange={(val) => {
                                                    const availStreamIds = this.streamIdsFor(selectedBranchObjs, val);
                                                    const availSectionIds = this.sectionIdsFor(selectedBranchObjs, val, availStreamIds);
                                                    this.setState({ classSearch: val, streamSearch: availStreamIds, sectionSearch: availSectionIds, classMultiError: "" });
                                                    this.ensureStreamsLoaded(val);
                                                }}
                                                placeholder="All Classes"
                                            />
                                            {this.state.classMultiError && (
                                                <div className="diary-field-error"><i className="fas fa-exclamation-circle" /> {this.state.classMultiError}</div>
                                            )}
                                        </Col>

                                        {showStream && (
                                            <Col lg={3} md={6} sm={12}>
                                                <label className="diary-filter-label2">Stream</label>
                                                <CheckboxDropdown
                                                    options={streamOptions}
                                                    value={streamSearch}
                                                    onChange={(val) => {
                                                        const availSectionIds = this.sectionIdsFor(selectedBranchObjs, classSearch, val);
                                                        this.setState({ streamSearch: val, sectionSearch: availSectionIds });
                                                    }}
                                                    placeholder="All Streams"
                                                />
                                            </Col>
                                        )}

                                        <Col lg={3} md={6} sm={12}>
                                            <label className="diary-filter-label2">Section</label>
                                            <CheckboxDropdown
                                                options={sectionOptions}
                                                value={sectionSearch}
                                                onChange={(val) => this.setState({ sectionSearch: val, sectionMultiError: "" })}
                                                placeholder="All Sections"
                                            />
                                            {this.state.sectionMultiError && (
                                                <div className="diary-field-error"><i className="fas fa-exclamation-circle" /> {this.state.sectionMultiError}</div>
                                            )}
                                        </Col>

                                        <Col lg={3} md={6} sm={12}>
                                            <label className="diary-filter-label2" aria-hidden="true">&nbsp;</label>
                                            <button className="diary-fee-search" onClick={this.getDisplayMultiSelectData}>
                                                <i className="fas fa-search" /> Search
                                            </button>
                                        </Col>
                                    </Row>

                                    {/* Stats Row */}
                                    {/* {recordCount > 0 && !this.state.loader && (
                                    <div className="diary-stats-row">
                                        <div className="diary-stat-card">
                                            <span className="stat-label">Total {typeName}s</span>
                                            <span className="stat-value">{recordCount}</span>
                                            <span className="stat-sub">in selected range</span>
                                        </div>
                                        {isDiary && (
                                            <div className="diary-stat-card stat-green">
                                                <span className="stat-label">Subjects</span>
                                                <span className="stat-value">
                                                    {[...new Set(this.state.studentDairyNoticeCreationDetails.map(i => i.subject_name))].length}
                                                </span>
                                                <span className="stat-sub">unique subjects</span>
                                            </div>
                                        )}
                                        <div className="diary-stat-card stat-cyan">
                                            <span className="stat-label">Date Range</span>
                                            <span className="stat-value" style={{ fontSize: 14 }}>
                                                {moment.unix(this.state.startDateCalender).format("DD MMM")}
                                                {" – "}
                                                {moment.unix(this.state.endDateCalender).format("DD MMM YY")}
                                            </span>
                                            <span className="stat-sub">selected period</span>
                                        </div>
                                    </div>
                                )} */}

                                    {/* Shimmer Loader */}
                                    {this.state.loader === 1 && (
                                        <div className="diary-shimmer-wrap">
                                            <div className="diary-shimmer-head">
                                                {[60, 120, 90, 80, 70, 60, 80].map((w, i) => (
                                                    <span key={i} className="diary-shimmer" style={{ height: 13, width: w }} />
                                                ))}
                                            </div>
                                            {[1, 2, 3, 4, 5, 6].map((r) => (
                                                <div key={r} className="diary-shimmer-row">
                                                    {[60, 120, 90, 80, 70, 60, 80].map((w, i) => (
                                                        <span key={i} className="diary-shimmer" style={{ height: 12, width: w }} />
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* PDF/Print Loader */}
                                    {this.state.loader === 2 && (
                                        <div className="diary-shimmer-wrap" style={{ textAlign: "center", padding: "80px 20px" }}>
                                            <div className="spinner-border text-primary" role="status" style={{ width: "3.5rem", height: "3.5rem", borderWidth: "4px" }}>
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                            <h5 className="mt-4" style={{ fontWeight: 700, color: "#1e293b" }}>Preparing PDF Document</h5>
                                            <p style={{ color: "#64748b", fontSize: "13px", maxWidth: "320px", margin: "8px auto 0" }}>
                                                Please wait while we fetch the organization details and compile the report.
                                            </p>
                                        </div>
                                    )}

                                    {/* Table or empty state */}
                                    {this.state.loader === 0 && recordCount > 0 ? (
                                        <div className="diary-table-container">
                                            {isDiary ? (
                                                <CardLessDataTableWithSearch parentData={formattedRegistryData} particlecolumns={articlecolumns} />
                                            ) : (
                                                <CardLessDataTableWithSearch parentData={sortedData} particlecolumns={noticeColumns} />
                                            )}
                                        </div>
                                    ) : (
                                        this.state.noDateError && this.state.loader === 0 && (
                                            <div className="diary-empty-state">
                                                <div className="diary-empty-icon">📭</div>
                                                <div className="diary-title">No {typeName}s Found</div>
                                                <div className="diary-subtitle">
                                                    Try adjusting your date range or filter selection
                                                </div>
                                            </div>
                                        )
                                    )}
                                </div>
                                </>
                                ) : (
                                    <AddDiary
                                        branches={this.state.branches}
                                        allClasses={this.state.getClasses}
                                        streams={this.state.allStreams}
                                        onNeedStreams={this.ensureStreamsLoaded}
                                        globals={this.props.globals}
                                        editItems={this.state.editItems}
                                        onCancel={() => this.setActiveTab("registry")}
                                        onSubmitSuccess={() => {
                                            this.getDisplayMultiSelectData({ preventDefault: () => {} }, { auto: true });
                                        }}
                                        addDairyAssignmentDetails={this.props.addDairyAssignmentDetails}
                                    />
                                )}
                            </div>
                        </Col>
                    </Row>

                    {/* ── Modals ── */}
                    {/* ── Modals ── */}
                    <NoticeModal
                        stateData={this.state}
                        show={this.state.viewNoticeModal}
                        onHide={() => this.setState({ viewNoticeModal: false })}
                        globals={this.props.globals}
                        getStudents={this.props.getStudents}
                        onSubmitSuccess={this.handleModalSubmitSuccess}
                    />
                    <DiaryResponseModal
                        stateData={this.state}
                        show={this.state.DiaryResponseModal}
                        onHide={() => this.setState({ DiaryResponseModal: false, modalDefaultTab: null })}
                        globals={this.props.globals}
                        defaultTabId={this.state.modalDefaultTab}
                    />
                    <PdfViewModal
                        stateData={this.state}
                        show={this.state.PdfViewModal}
                        onHide={() => this.setState({ PdfViewModal: false })}
                        globals={this.props.globals}
                    />
                    <DiaryTableRowDeleteModal
                        stateData={this.state}
                        show={this.state.DiaryTableRowDeleteModal}
                        onHide={() => this.setState({ DiaryTableRowDeleteModal: false })}
                        globals={this.props.globals}
                        handleDelete={this.handleDelete}
                    />

                    <Modal
                        show={this.state.previewModalOpen}
                        onHide={() => this.setState({ previewModalOpen: false })}
                        size="lg"
                        centered
                        dialogClassName="modal-90w"
                    >
                        <Modal.Header closeButton style={{ borderBottom: "none", paddingBottom: 0 }}>
                        </Modal.Header>
                        <Modal.Body style={{ padding: "0 24px 24px" }}>
                            <ClassDiaryPreview 
                                previewData={this.state.previewData} 
                                orgProfile={this.state.orgProfile} 
                            />
                        </Modal.Body>
                    </Modal>

                    {/* Shown instead of opening the create/edit form or deleting when the
                        grant is missing. One modal serves every intercepted action. */}
                    <AccessDeniedModal
                        show={this.state.accessDeniedShow}
                        onHide={this.guard.hideAccessDenied}
                    />

                </Container>
            </div>
        );
    }
}
export default withRouter(withApollo(compose(
    graphql(DELETE_DIARY_ROW_DATA, {
        name: "deleteDairyAssignmentData"
    }),
    graphql(EDIT_NOTICE_DIARY_DATA, {
        name: "addDairyAssignmentDetails"
    })
)(StundentDiaryHome)));